import {isFunction, uniq, isString} from "lodash";
import {firestore} from "../../config/firebaseConfig";

export const updateReceivingItem = (receivingId, receivedItem, callback = null) => {
    return async (dispatch) => {
        try {

            const docRef = firestore.collection('received_orders').doc(receivingId);

            await firestore.runTransaction(transaction => {
                return transaction.get(docRef).then(doc => {

                    if (doc.exists) {

                        const {ReceivedItems = []} = doc.data();

                        const list = ReceivedItems.map(one => {
                            return (one.ItemId === receivedItem.ItemId) ? receivedItem : one
                        })

                        transaction.update(docRef, {ReceivedItems: list})
                    }

                })
            })

            isFunction(callback) && callback()

        } catch (error) {
            console.error(error)
        }
    }
}

export const archiveReceiving = (collections, callback = null) => {
    return async () => {
        try {

            let list = [];

            collections.forEach(collection => {
                list = [...list, ...collection]
            })

            const result = list?.map(({id}) => id)

            const ids = uniq(result).filter(one => isString(one));

            const batch = firestore.batch();

            ids.forEach(id => {

                const meta = list.find(one => one?.id === id);
                const ref = firestore.collection('received_orders').doc(id);

                batch.update(ref, {
                    ActivityStatus: 'Archived',
                    PrevActivityStatus: meta?.ActivityStatus || 'Closed',
                    UpdateAt: new Date(),
                })

            })

            await batch.commit()

            isFunction(callback) && callback()

        } catch (e) {
            console.error(e)
        }
    }
}

export const reverseReceivingArchiving = (collections, callback = null) => {
    return async () => {
        try {

            const batch = firestore.batch();

            collections.forEach(({id, PrevActivityStatus}) => {

                const ref = firestore.collection('received_orders').doc(id);

                batch.update(ref, {
                    ActivityStatus: PrevActivityStatus || 'Closed',
                    PrevActivityStatus: 'Archived',
                    UpdateAt: new Date(),
                })

            })

            await batch.commit()

            isFunction(callback) && callback()

        } catch (e) {
            console.error(e)
        }
    }
}